import { PHASE_DEFINITIONS } from './mapProgresData';
import { formatDateBody } from '../../../../../utils/FormatDate';

const getField = (data, key) => {
  if (!data) return undefined;

  if (data[key] !== undefined && data[key] !== null) {
    return data[key];
  }

  const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
  if (data[pascalKey] !== undefined && data[pascalKey] !== null) {
    return data[pascalKey];
  }

  return undefined;
};

const normalizeDateForApi = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  return formatDateBody(value);
};

export const buildUpdatePayload = (rawData, overrides = {}) => {
  const data = { ...rawData, ...overrides };
  const payload = {
    id: getField(data, 'id'),
    ukupanProgres: getField(data, 'ukupanProgres'),
    predvidjeniDatumIzrada: normalizeDateForApi(
      getField(data, 'predvidjeniDatumIzrada'),
    ),
    idKorProm: +localStorage.idKorisnika,
  };

  PHASE_DEFINITIONS.forEach((def) => {
    payload[`${def.key}Progres`] = getField(data, `${def.key}Progres`);
    payload[`${def.key}Prikaz`] = getField(data, `${def.key}Prikaz`);
  });

  return payload;
};
